export default __webpack_public_path__ + "static/media/Chevron_left.64a6d1b2.svg";